import { ReactComponent as CouponSVG } from "./coupon.svg";
import { SvgIcon } from '@mui/material';

export default function IconCoupon(props) {
  return <SvgIcon {...props} component={CouponSVG} viewBox="0 0 25 24" />;
}